export var ForeignAdjudicatorDefaults = {
    id: 0,
    name: "",
    surname: "",
    country: "",
};
